import React from 'react';
import { Helmet } from 'react-helmet';
import { useTranslation } from 'react-i18next';

import Alert from 'reactstrap/lib/Alert';

import { receiveProducts } from '@ttstr/actions';
import { Container, LoadingSpinner, Masonry, useIntl, ContentrArea } from '@ttstr/components';
import { AppState } from '@ttstr/reducers';
import { useActions, useShallowEqualSelector } from '@ttstr/utils';
import FilteredMasonry from './FilteredMasonry';

const ProductListing: React.FC = () => {
  const { t } = useTranslation();
  const { loading, products } = useShallowEqualSelector(mapStateToProps);
  const { receiveProducts } = useActions(mapDispatchToProps);
  const { language } = useIntl();

  React.useEffect(() => {
    receiveProducts();
  }, [language]);

  return (
    <article>
      <Container fluid className="header-image" />

      <ContentrArea id="before-listing" />

      <Container className="list-page mb-5">
        <Helmet>
          <title>{t(`PRODUCTS.TITLE`)}</title>
          <body className="product-listing-page" />
        </Helmet>

        {/* <Container fluid className="header-image" /> */}

        {/* <div className="text-center">
          <img src={require('./assets/images/home-logo.svg')} alt="" className="img-fluid w-50 my-5" />
        </div> */}

        {loading ? ( // if loading
          <LoadingSpinner label={t(`LOADING.PRODUCTS`)} />
        ) : products.length === 0 ? ( // if no products
          <Alert color="info" className="mt-5">
            {t(`MASONRY.NO_ITEMS`)}
          </Alert>
        ) : (
          // else show products
          <Masonry
            id="product-listing"
            products={products}
            columnClassName="col-sm-12 col-md-6 col-lg-4"
            filters="off"
            showFormerPrice
            showSubtitle
            showTags
          />
        )}
      </Container>
    </article>
  );
};

const mapStateToProps = (state: AppState) => {
  const { products, loading } = state.Products;
  return {
    products,
    loading,
  };
};

const mapDispatchToProps = {
  receiveProducts,
};

export default React.memo(ProductListing);
